import React, { useState } from "react";
import { Helmet } from "react-helmet-async"; // ← pour le JSON-LD
import "../style/Faq.css";
import { CloseOutlined, PlusOutlined } from "@ant-design/icons";

/* ---------- Data (ajout de aText pour le JSON-LD) ---------- */
const faqs = [
  {
    q: "Comment créer ma boutique Fastline ?",
    aText:
      "Créer votre boutique est simple. Il suffit de créer votre compte Fastline, d’ajouter une boutique, puis de configurer votre compte Stripe en complétant les informations demandées. Une fois Stripe validé, vous pouvez ajouter vos produits et commencer à vendre.",
    a: (
      <p>
        Créer votre boutique est simple. Il suffit de créer votre compte Fastline, d’ajouter une boutique, puis de configurer votre compte Stripe en complétant les informations demandées. Une fois Stripe validé, vous pouvez ajouter vos produits et commencer à vendre.
      </p>
    ),
  },
  {
    q: "Combien coûte Fastline ?",
    aText:
      "Fastline fonctionne sans abonnement. Vous payez uniquement une commission de 6% sur chaque vente réalisée. Si vous ne vendez rien, vous ne payez rien. Cette commission couvre les frais de gestion de la plateforme, la sécurisation des paiements, l’infrastructure technique, ainsi que le maintien et l’évolution continue du service.",
    a: (
      <p>
        Fastline fonctionne sans abonnement. Vous payez uniquement une commission de 6% sur chaque vente réalisée. Si vous ne vendez rien, vous ne payez rien.
        <br /><br />
        Cette commission couvre les frais de gestion de la plateforme, la sécurisation des paiements, l’infrastructure technique, ainsi que le maintien et l’évolution continue du service.
      </p>
    ),
  },
  {
    q: "Comment fonctionnent les paiements ?",
    aText:
      "Les paiements passent directement par Stripe et l’argent est versé sur votre compte. Fastline prélève automatiquement sa commission, vous gardez le reste.",
    a: (
      <p>
        Les paiements passent directement par Stripe et l’argent est versé sur votre compte. Fastline prélève automatiquement sa commission, vous gardez le reste.
      </p>
    ),
  },
  {
    q: "Quand est-ce que je reçois mon argent ?",
    aText:
      "Stripe effectue des virements automatiques tous les jours. Les ventes réalisées aujourd’hui sont généralement versées sur votre compte bancaire le lendemain, selon les délais de Stripe.",
    a: (
      <p>
        Stripe effectue des virements automatiques tous les jours. Les ventes réalisées aujourd’hui sont généralement versées sur votre compte bancaire le lendemain, selon les délais de Stripe.
      </p>
    ),
  },
  {
    q: "Combien de temps pour créer ma boutique Fastline ?",
    aText:
      "Vous pouvez créer votre boutique en 30 minutes à 1 heure. Tout est simplifié pour vous permettre de vendre rapidement, sans compétences techniques.",
    a: (
      <p>
        Vous pouvez créer votre boutique en 30 minutes à 1 heure. Tout est simplifié pour vous permettre de vendre rapidement, sans compétences techniques.
      </p>
    ),
  },
  {
    q: "Qui gère les commandes et la livraison ?",
    aText:
      "Vous gérez vous-même vos commandes et votre livraison. Fastline vous fournit les outils pour vendre, mais vous gardez le contrôle total de votre activité.",
    a: (
      <p>
        Vous gérez vous-même vos commandes et votre livraison. Fastline vous fournit les outils pour vendre, mais vous gardez le contrôle total de votre activité.
      </p>
    ),
  },
  {
    q: "Pourquoi choisir Fastline plutôt que Shopify ou Uber Eats ?",
    aText:
      "Fastline offre une solution simple, rapide et sans abonnement. Contrairement à Shopify ou Uber Eats, vous pouvez lancer votre boutique rapidement, avec des frais réduits et un paiement sécurisé via Stripe.",
    a: (
      <div>
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr style={{textAlign:'left'}}>
              <th></th>
              <th>Fastline</th>
              <th>Shopify</th>
              <th>Uber Eats</th>
            </tr>
          </thead>
          <tbody>
  
            <tr>
              <td ><b>Tarifs</b></td>
              <td>Gratuit + 6% commission</td>
              <td>~30€/mois + apps</td>
              <td>Frais d'inscription + jusqu’à 30% commission</td>
            </tr>
  
            <tr>
              <td ><b>Fiabilité</b></td>
              <td>Paiement sécurisé via Stripe</td>
              <td>Paiement via Shopify Payments / Stripe</td>
              <td>Paiement géré par Uber</td>
            </tr>
  
            <tr>
              <td ><b>Mise en place</b></td>
              <td>~ 45 minutes</td>
              <td>Plusieurs heures / jours</td>
              <td>1/3 semaines</td>
            </tr>
          </tbody>
        </table>
      </div>
    ),
  }
];

/* ---------- Component ---------- */
export default function Faq() {
  const [open, setOpen] = useState(null);

  const toggle = (idx) => () => setOpen((cur) => (cur === idx ? null : idx));

  // JSON-LD FAQPage (rich result)
  const faqJsonLd = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map(({ q, aText }) => ({
      "@type": "Question",
      name: q,
      acceptedAnswer: { "@type": "Answer", text: aText },
    })),
  };

  return (
    <section className="faq">
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify(faqJsonLd)}
        </script>
      </Helmet>

      {faqs.map(({ q, a }, idx) => {
        const isOpen = open === idx;
        return (
          <div key={idx} className="item">
            {/* Question row */}
            <button
              className="question"
              aria-expanded={isOpen}
              onClick={toggle(idx)}
            >
              <h2 className="texte">{q}</h2>
              <span aria-hidden="true">
                {isOpen ? (
                  <CloseOutlined className="icone" />
                ) : (
                  <PlusOutlined className="icone" />
                )}
              </span>
            </button>

            {/* Answer panel */}
            <div className="answer" hidden={!isOpen} aria-hidden={!isOpen}>
  {a}
</div>         
 </div>
        );
      })}
    </section>
  );
}
